"use client";
import { useState } from "react";

const HEARD_FROM_OPTIONS = [
  "Parent",
  "Student",
  "Faculty",
  "Partner",
  "Other"
];

const COURSE_OPTIONS = [
  { value: "", label: "Search School" },
  { value: "school-health-science", label: "School of Health Science and Technology" },
  { value: "school-beauty-wellness", label: "School of Beauty and Wellness" },
  { value: "school-indigenous", label: "School of Indigenous Knowledge, Research, and Applications" },
  { value: "school-media", label: "School of Modern Media and Entertainment" },
  { value: "school-design", label: "School of Design" },
  { value: "school-applied-science", label: "School of Applied Science and Technology" },
  { value: "school-cse", label: "School of Computer Science Engineering" },
  { value: "school-hospitality", label: "School of Hospitality and Tourism" },
  { value: "school-management", label: "School of Management and Commerce" },
];

const INDIAN_STATES_UTS = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

const selectStyles = {
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right 1rem center",
};

export function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    heardFrom: "",
    course: "",
    country: "India",
    state: "",
    city: "",
    emailUpdates: false,
  });
  const payload = {
  ...formData,
  heardFrom:
    formData.heardFrom === "Other"
      ? formData.otherHeardFrom
      : formData.heardFrom,
};
  const [IsSubmitted, SetSubmission] = useState(false)
  const handleSubmit = async (e) => {
    e.preventDefault();
    SetSubmission(true)
    const res = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    

    const data = await res.json();
    if (!data.ok) return alert(data.error || "Failed");



    const response1 = await fetch("/api/zoho/contact-us", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name : formData.name,
          email: formData.email,
          Phone: formData.mobile,
          Source: "Contact Us Form"
        }),
      });

      const datalist = await response1.json();
      console.log("data list is ", datalist);

    alert("Thank you for contacting us. We have received your message and will get back to you shortly.");
    // console.log("Form Data Submitted:", formData);
    SetSubmission(false)

    setFormData({
      name: "",
      email: "",
      mobile: "",
      heardFrom: "",
      // course: "",
      country: "India",
      state: "",
      messege: "",
      emailUpdates: false,
    });
  };

  return (
    <div className="bg-white border-2 border-gray-200 p-8">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Name + Email */}
        <div className="grid grid-cols-2 gap-4">
          <input
            type="text"
            placeholder="Enter your Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400] transition-colors"
            required
          />

          <input
            type="email"
            placeholder="Enter your Email Addr"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400] transition-colors"
            required
          />

        </div>
        <div>
           <input
            type="tel"
            placeholder="Enter Mobile Number"
            value={formData.mobile}
            onChange={(e) => setFormData({ ...formData, mobile: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400] transition-colors"
            required
          />
        </div>

        {/* Mobile + Heard From (Dropdown) */}
        <div>
          <p className="text-sm text-gray-700 mb-2">I am a</p>

          <select
            value={formData.heardFrom}
            onChange={(e) =>
              setFormData({
                ...formData,
                heardFrom: e.target.value,
                otherHeardFrom: e.target.value === "Other" ? formData.otherHeardFrom : "",
              })
            }
            className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400] transition-colors bg-white appearance-none"
            style={selectStyles}
            required
          >
            <option value="">Select Option</option>
            {HEARD_FROM_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>

          {/* Show only when OTHERS is selected */}
        {formData.heardFrom === "Other" && (
            <div className="col-span-2 mt-4">
              <input
                type="text"
                placeholder="Please specify"
                value={formData.otherHeardFrom}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    otherHeardFrom: e.target.value,
                  })
                }
                className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400]"
                minLength={4}
                maxLength={25}
                required
              />
            </div>
          )}
          
        </div>

        {/* State */}
        <div>
          <p className="text-sm text-gray-700 mb-2">Your State</p>
          <select
            value={formData.state}
            onChange={(e) => setFormData({ ...formData, state: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400] transition-colors bg-white appearance-none"
            style={selectStyles}
            required
          >
            <option value="" disabled>Select Your State</option>
            {INDIAN_STATES_UTS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        {/* Course */}
        {/* <div>
          <p className="text-sm text-gray-700 mb-2">Choose your programme</p>
          <select
            value={formData.course}
            onChange={(e) => setFormData({ ...formData, course: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400] transition-colors bg-white appearance-none"
            style={selectStyles}
            required
          >
            {COURSE_OPTIONS.map((c) => (
              <option key={c.value} value={c.value}>
                {c.label}
              </option>
            ))}
          </select>
        </div> */}

        {/* Country + State */}
        <div className="col-span-3">
          <textarea
            placeholder="Enter Message"
            value={formData.messege}
            onChange={(e) =>
              setFormData({ ...formData, messege: e.target.value })
            }
            rows={3}
            className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:border-[#E09400] transition-colors resize-none"
            required
          />
        </div>
        {/* Checkbox */}
        <div className="flex items-start gap-3">
          <input
            type="checkbox"
            id="emailUpdates"
            checked={formData.emailUpdates}
            onChange={(e) => setFormData({ ...formData, emailUpdates: e.target.checked })}
            className="mt-1 w-4 h-4 border-gray-300 accent-[#E09400]"
            required
          />
          <label htmlFor="emailUpdates" className="text-sm text-gray-600 leading-relaxed">
            I agree to receive updates and notifications via Email/SMS/WhatsApp/Call by signing up on Medhavi Skills
            University (Sikkim). This will override DND/NDNC.*
          </label>
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={IsSubmitted}
          className={`w-full py-4 text-base uppercase tracking-wide transition-colors
            ${IsSubmitted
              ? "bg-[#caa24d] cursor-not-allowed opacity-70"
              : "bg-[#E09400] hover:bg-[#c77f00] text-white"}
          `}
        >
          {IsSubmitted ? (
            <div className="flex items-center justify-center gap-3">
              <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              Submitting...
            </div>
          ) : (
            "SUBMIT"
          )}
        </button>

      </form>
    </div>
  );
}